import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton } from "@fluentui/react";
import React from "react";

type DialogVariant = "danger" | "success";

const variantClassMap: Record<DialogVariant, string> = {
  danger: "dialog__primary--button",
  success: "dialog__primary--button dialog--success",
};

interface ConfirmDialogProps {
  title?: string;
  subText?: string;
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: DialogVariant;
  confirmText?: string;
  confirmDisabled?: boolean;
  children?: React.ReactNode;
}

const ConfirmationDialog = ({
  onConfirm,
  onCancel,
  isVisible,
  title = "Are you sure?",
  subText = "Are you sure you want to cancel the operation.",
  variant = "danger",
  confirmText = "Yes, Continue",
  confirmDisabled = false,
  children,
}: ConfirmDialogProps) => {
  const dialogContentProps: IDialogContentProps = {
    type: DialogType.normal,
    title,
    subText,
    styles: {
      title: {
        color: "white",
      },
      subText: {
        color: "#A19F9D",
      },
    },
  };

  return (
    <Dialog
      hidden={!isVisible}
      onDismiss={onCancel}
      dialogContentProps={dialogContentProps}
      modalProps={{
        isBlocking: true,
        styles: {
          main: { maxWidth: 450, backgroundColor: "#323130", color: "white" },
        },
      }}
    >
      {children}
      <DialogFooter>
        <PrimaryButton
          onClick={onConfirm}
          text={confirmText}
          disabled={confirmDisabled}
          className={confirmDisabled ? "dialog__primary--disabled" : variantClassMap[variant]}
        />
        <DefaultButton onClick={onCancel} text="No" className="dialog__secondary--button" />
      </DialogFooter>
    </Dialog>
  );
};

export default ConfirmationDialog;
